<template>
    <span @click="toggleVersion" class="slw-version">{{ displayedVersion }}</span>
</template>

<script>
import { ref, computed } from 'vue'
import versions from '@/utilities/Version.js'
const debug = require('debug')('xlite-web-client:versions')

export default {
    setup() {
        const { version, detailedVersion } = versions()
        const isDetailedVersion = ref(false)
        const displayedVersion = computed(() => isDetailedVersion.value ? detailedVersion : version)

        const toggleVersion = () =>{
            debug(`isDetailedVersion ${isDetailedVersion.value}`)
            isDetailedVersion.value = !isDetailedVersion.value
        }

        return {
            displayedVersion,
            toggleVersion
        }
    }    
}
</script>

<style>
    .slw-version {
        font-size: 10px;
        color: gray;
    }
</style>
